import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { User } from "../services/authService";

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  expiresAt: number | null;
  user: User | null;
  isAuthenticated: boolean;
  // For MFA flow
  mfaSessionId: string | null;
  mfaMethod: string | null;
  mfaPending: boolean;
  setAuth: (
    accessToken: string,
    refreshToken: string,
    expiresAt: number,
    user: User,
  ) => void;
  setMFAPending: (
    sessionId: string,
    method: string,
    accessToken: string,
    refreshToken: string,
  ) => void;
  clearMFAPending: () => void;
  logout: () => void;
  // For backward compatibility with existing code
  token: string | null;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      expiresAt: null,
      user: null,
      isAuthenticated: false,
      mfaSessionId: null,
      mfaMethod: null,
      mfaPending: false,
      // token field is deprecated, use accessToken
      token: null,
      setAuth: (accessToken, refreshToken, expiresAt, user) => {
        console.log(
          "[authStore] setAuth called with token:",
          accessToken ? accessToken.substring(0, 50) + "..." : "null",
        );
        set({
          accessToken,
          refreshToken,
          expiresAt,
          user,
          isAuthenticated: true,
          mfaSessionId: null,
          mfaMethod: null,
          mfaPending: false,
          token: accessToken, // For backward compatibility
        });
      },
      setMFAPending: (sessionId, method, accessToken, refreshToken) =>
        set({
          mfaSessionId: sessionId,
          mfaMethod: method,
          mfaPending: true,
          isAuthenticated: false,
          accessToken: accessToken,
          refreshToken: refreshToken,
          token: accessToken, // For backward compatibility - allows authRequest to use the token
        }),
      clearMFAPending: () =>
        set({
          mfaSessionId: null,
          mfaMethod: null,
          mfaPending: false,
        }),
      logout: () =>
        set({
          accessToken: null,
          refreshToken: null,
          expiresAt: null,
          user: null,
          isAuthenticated: false,
          mfaSessionId: null,
          mfaMethod: null,
          mfaPending: false,
          token: null,
        }),
    }),
    {
      name: "tradecraft-auth",
    },
  ),
);
